import {
    assignmentsColumns,
    sortDirection
} from "../../../components/assignments/assignmentsPage/assignmentsList/AssignmentsConstants";
import isEmpty from "../../../helpers/isEmpty";

class ExpressionBuilder {
    constructor() {
        this.skip = '0';
        this.top = '50';
        this.orderby = assignmentsColumns.startDate;
        this.direction = sortDirection.ascending;
        this.filter = '';
    }

    withPageOptions(options) {
        const {page, pageSize} = options;
        this.skip = (page - 1) * pageSize;
        this.top = pageSize;
        return this;
    }

    withSortOptions(options) {
        const {columnName, direction} = options;
        this.orderby = columnName;
        this.direction = direction;
        return this;
    }

    withFilterOptions(options) {
        this.filter = this.mapFilterOptionsToExpression(options);
        return this;
    }

    mapFilterOptionsToExpression(options) {
        if (!options) return '';

        const {groupFilterItems} = options;
        if (!groupFilterItems) return '';

        let expression = "";
        const {status} = groupFilterItems;
        expression = statusExpressionReducer(expression, status);

        if (!expression) return '';
        return `&$filter=${expression}`;
    }

    toExpression() {
        const {skip, top, orderby, direction, filter} = this;
        return `$orderby=${orderby} ${direction}`;
    }
}
export default new ExpressionBuilder();

const optionsReducer = (field, equalityExpression) => (exp, opt, i) => {
    const conditionalOr = i === 0 ? exp : `${exp} or `;
    return `${conditionalOr}${equalityExpression(field, opt.id)}`;
};
const statusExpressionReducer = (expression = '', options = []) => {
    if (isEmpty(options)) return expression;

    const selectedOptions = options.filter(opt => opt.isSelected);
    if (isEmpty(selectedOptions)) return expression;

    const startExpression = !expression ? '(' : `${expression} and (`;
    return selectedOptions.reduce(optionsReducer('Status', simpleStringEqualityExpression), startExpression).concat(')');
};
const simpleStringEqualityExpression = (field, value) => {
    return `tolower(${field}) eq tolower('${value}')`;
};


